module.exports = __webpack_public_path__ + "static/media/timer-green.b1f8b39c.svg";